export default "0b32ab658cef096c.svg"